import React from "react";

/**
 * @component MoveIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 *
 * @example
 * return (
 *   <MoveIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const MoveIcon = React.forwardRef(
  (props: React.SVGProps<SVGSVGElement>, svgRef?: React.Ref<SVGSVGElement>) => (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="MoveIcon"
      fill="var(--color-theme-600)"
      focusable={false}
      ref={svgRef}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 16a2 2 0 01-2-2V4a2 2 0 012-2h10a2 2 0 011.995 1.85L16 4H4v10h7v-3l4 4-4 4v-3H4zm15 4V8H8v4H6V8a2 2 0 012-2h11a2 2 0 012 2v12a2 2 0 01-2 2H8a2 2 0 01-2-2v-2h2v2h11z"
      />
    </svg>
  )
);
MoveIcon.displayName = "MoveIcon";
export default MoveIcon;
